
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CPOpenAccountFormActionBlock extends Vue {
  @Prop()
  public readonly title!: string;

  @Prop()
  public readonly summary?: string;
}
